import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, iconButtonLook } from 'components/Buttons/look'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
`

/* O texto não passa por baixo do olho. */
export const Input = styled(BaseInput)`
  padding-right: 36px;
`

export const EyeToggle = styled(LookButton).attrs({ type: 'button' }).attrs(iconButtonLook())`
  position: absolute;
  right: 4px;
`
